module.exports = __webpack_public_path__ + "img/Gallery_3_10.ff9540ba.jpeg";